import { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { SingleModifiedDateFilter } from '~/components/Filters/DateFilter/SingleModifiedDateFilter';
import { FilterTrigger } from '~/components/Filters/SingleFilters/FilterTrigger';
import { type SingleFilterProps } from '~/components/Filters/types';
import { baseFiltersOptions } from '~/components/FiltersMenu/types';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { removeFilterAction } from '~/store/filters/actions';
import { type SelectedFilter } from '~/store/filters/types';

export type ModifiedDateFilterTriggerProps = SingleFilterProps;

export const ModifiedDateFilterTrigger = memo(
  ({ onApplyClick, onRemoveClick, onOpenChange }: ModifiedDateFilterTriggerProps) => {
    const dispatch = useDispatch();
    const { updatedDateParam } = useFilterParams();

    const content = useMemo(() => <SingleModifiedDateFilter onApplyClick={onApplyClick} />, [onApplyClick]);

    const removeFilter = useCallback(async () => {
      const filter: SelectedFilter = { type: 'dateModified' };
      dispatch(removeFilterAction({ filter }));
      onRemoveClick?.([filter]);
    }, [dispatch, onRemoveClick]);

    return (
      <FilterTrigger
        count={updatedDateParam?.start || updatedDateParam?.end ? 1 : 0}
        filterContent={content}
        title={baseFiltersOptions['dateModified'].label}
        Icon={baseFiltersOptions['dateModified'].icon}
        onRemoveClick={removeFilter}
        onOpenChange={onOpenChange}
      />
    );
  },
);

ModifiedDateFilterTrigger.displayName = 'ModifiedDateFilterTrigger';
